/* Icona deterministica della strategia. Il colore dice la famiglia, il motivo
 * dice il membro; nessun verde, nessun rosso, nessun teal, perché qui
 * significano guadagno, perdita e marchio.
 *
 * Se il generatore non è disponibile si mostra un ripiego con le iniziali
 * invece di un buco: una riga senza icona si legge come una riga rotta. */

import { tesseraStrategia } from '../lib/iconaStrategia';

export function IconaStrategia({ nome, dim = 24 }: { nome: string; dim?: number }) {
  const tessera = tesseraStrategia(nome, dim);

  if (tessera) {
    return (
      <span className="sb-icona-strategia" title={nome} aria-hidden="true">
        {tessera}
      </span>
    );
  }

  const iniziali = nome.replace(/[^A-Za-z0-9]/g, '').slice(0, 2).toUpperCase();
  return (
    <span
      className="sb-icona-strategia sb-icona-strategia__ripiego"
      style={{ width: dim, height: dim }}
      title={nome}
      aria-hidden="true"
    >
      {iniziali}
    </span>
  );
}
